export const SET = 'Analysis/data/Collectors/SET';

export function setCollectors(collectors) {
  return {
    type: SET,
    collectors
  }
}